import React, { useState } from "react";
import ScorerPopup from "./ScorerPopup";
import LoadingCircle from "../../../../LoadingCircle";

interface ProposedResultProps {
  result: {
    id: number;
    score_home: number;
    score_guest: number;
    submitted_by: number;
    submitted_by_user: {
      id: number;
      name: String;
    };
    is_final: boolean;
    scorer: {
      id: number;
      user_id: number;
      team_id: number;
      goal_count: number;
    }[];
  };
  isMyResult: boolean;
  isAdmin: boolean;
  onAccept: (resultId: number) => Promise<void>;
  loadingAcceptResult: boolean;
  ownTeamId: number;
  matchId: number;
  homeTeamId: number;
  guestTeamId: number;
}

const ProposedResult: React.FC<ProposedResultProps> = ({
  result,
  isMyResult,
  isAdmin,
  onAccept,
  loadingAcceptResult,
  ownTeamId,
  matchId,
  homeTeamId,
  guestTeamId,
}) => {
  const [showScorerPopup, setShowScorerPopup] = useState(false);
  const isHomeTeam = ownTeamId === homeTeamId;
  const allowedGoals = isHomeTeam ? result.score_home : result.score_guest;

  return (
    <div className="flex border mb-1 border-white p-2 rounded-xl justify-between">
      <div>
        <p>
          Result: {result.score_home} : {result.score_guest}
        </p>
        <p>Proposed by: {isMyResult ? "Me" : result.submitted_by_user?.name}</p>
      </div>
      <div className="flex flex-wrap justify-end gap-3">
        <div className="py-2 px-4 flex items-center rounded-xl font-semibold text-orange-500 border-2 border-orange-500 bg-white">
          Pending
        </div>
        {(!isMyResult || isAdmin) && (
          <button
            onClick={() => onAccept(result.id)}
            className={`py-2 px-4 flex items-center rounded-xl font-semibold bg-green-500 ${
              loadingAcceptResult ? "" : "hover:bg-green-600"
            }`}
            disabled={loadingAcceptResult}
          >
            {loadingAcceptResult ? (
              <LoadingCircle small={true} />
            ) : (
              <p>Accept</p>
            )}
          </button>
        )}
        {allowedGoals > 0 && (
          <button
            onClick={() => setShowScorerPopup(true)}
            className="py-2 px-4 rounded-xl bg-blue-500 hover:bg-blue-600 text-white"
          >
            Edit Scorer
          </button>
        )}
      </div>
      {showScorerPopup && (
        <ScorerPopup
          teamId={ownTeamId}
          matchId={matchId}
          resultId={result.id}
          allowedGoals={allowedGoals}
          initialGoals={result.scorer.filter(s => (s.team_id === ownTeamId))}
          onClose={() => setShowScorerPopup(false)}
        />
      )}
    </div>
  );
};
export default ProposedResult;
